/* eslint-disable max-lines */
/* eslint-disable max-lines-per-function */
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import NavigateNextRoundedIcon from '@mui/icons-material/NavigateNextRounded';
import { RootState } from '../../redux/store';
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

import './landing.css';
import '@fontsource/dm-sans/400.css';
import '@fontsource/caveat/700.css';

const brand = {
    50: 'hsl(223, 100%, 95%)',
    100: 'hsl(223, 100%, 92%)',
    200: 'hsl(223, 100%, 80%)',
    300: 'hsl(223, 100%, 69%)',
    400: 'hsl(223, 98%, 48%)',
    500: 'hsl(223, 98%, 42%)',
    600: 'hsl(223, 98%, 55%)',
    700: 'hsl(223, 100%, 35%)',
    800: 'hsl(223, 100%, 16%)',
    900: 'hsl(223, 100%, 21%)'
};

const DownArrowIcons = () => {
    return (
        <Box className="flex flex-row items-center justify-around" marginY={4}>
            <svg width="80px" height="40px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="rgba(128,160,240,1)" aria-hidden="true" className="solid">
                <path fillRule="evenodd" d="M20.03 4.72a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 011.06-1.06L12 11.69l6.97-6.97a.75.75 0 011.06 0zm0 6a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 111.06-1.06L12 17.69l6.97-6.97a.75.75 0 011.06 0z" clipRule="evenodd">

                </path>
            </svg>
            <svg width="80px" height="40px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="rgba(128,160,240,1)" aria-hidden="true" className="solid">
                <path fillRule="evenodd" d="M20.03 4.72a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 011.06-1.06L12 11.69l6.97-6.97a.75.75 0 011.06 0zm0 6a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 111.06-1.06L12 17.69l6.97-6.97a.75.75 0 011.06 0z" clipRule="evenodd">

                </path>
            </svg>
            <svg width="80px" height="40px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="rgba(128,160,240,1)" aria-hidden="true" className="solid">
                <path fillRule="evenodd" d="M20.03 4.72a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 011.06-1.06L12 11.69l6.97-6.97a.75.75 0 011.06 0zm0 6a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 111.06-1.06L12 17.69l6.97-6.97a.75.75 0 011.06 0z" clipRule="evenodd">

                </path>
            </svg>
        </Box>
    );
};

const LandingPage = () => {
    const navigate = useNavigate();
    const { token } = useSelector((state: RootState) => state.app);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const routeToSignup = () => navigate('/signup');
    // const routeToSignup = () => window.open('https://oca.gonzy.com/oca-challenge', '_self', 'noopener,noreferrer');

    useEffect(() => {
        if (token) {
            navigate('/login');
        }
        setTimeout(() => {
            setIsLoading(false);
        }, 1000);
    }, [token]);

    if (isLoading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="100vh" width="100vw" position="fixed" top={0} left={0} zIndex={1300} bgcolor="background.default">
                <Box textAlign="center">
                    <CircularProgress size={60} />
                    <Typography variant="h6" fontWeight="bold" mt={2}>
                        Loading...
                    </Typography>
                </Box>
            </Box>
        );
    }

    return (
        <div className="overflow-hidden">
            {/* First block */}
            <Box
                className=""
                sx={{
                    backgroundImage: 'url(/assets/GOBackgrounds1.png)',
                    minHeight: '75vh',
                    width: '100%',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover'
                }}
            >
                {/* Navbar */}
                <Box className="flex flex-row justify-around" paddingTop={4}>
                    {/* Logo */}
                    <Box>
                        <img src="/assets/logo-light.png" alt="logo" width={200} height={50} style={{ width: 150, height: 40 }} />
                    </Box>
                    <Box className="flex flex-row justify-between gap-x-4">
                        <Button onClick={() => navigate('/login')}>
                            <Typography color="#616161" fontFamily="'DM Sans', sans-serif" fontWeight={300} >
                                Login
                            </Typography>
                        </Button>
                        <Button sx={{
                            'backgroundColor': brand[300],
                            'borderRadius': 100,
                            'px': 5,
                            'py': 2,
                            '&:hover': {
                                backgroundColor: brand[400]
                            }
                        }}
                            onClick={routeToSignup}
                        >
                            <Typography color="white" fontFamily="'DM Sans', sans-serif" fontWeight={900} letterSpacing={1} >
                                Get Gonzy
                            </Typography>
                        </Button>
                    </Box>
                </Box>
                {/* Content Get Gonzy 1 */}
                <Box className="flex flex-col items-center justify-center">
                    <Box marginTop={4}>
                        <Typography variant="h3" fontFamily="'DM Sans', sans-serif" fontWeight={900} letterSpacing={-0.5} textAlign={'center'} className="text-balance">
                            Automate Your Client
                        </Typography>
                        <Typography variant="h3" fontWeight={900} fontFamily="'DM Sans', sans-serif" textAlign={'center'} letterSpacing={-0.5} className="text-balance">
                            Acquisition & Fulfillment
                        </Typography>
                        <Typography variant="h3" fontFamily="'DM Sans', sans-serif" fontWeight={900} textAlign={'center'} letterSpacing={-0.5} className="text-balance">
                            With The Push Of A Button
                        </Typography>
                    </Box>
                    <Box marginTop={2}>
                        <Typography fontWeight={700} fontFamily="'Caveat', cursive" variant="h4" className="text-center text-balance">
                            Meet Gonzy: The #1 Client-Getting &
                        </Typography>
                        <Typography fontWeight={700} fontFamily="'Caveat', cursive" variant="h4" className="text-center text-balance">
                            Management Software For Agency Owners
                        </Typography>
                    </Box>
                    <Box marginTop={5} width="15%">
                        <Button sx={{
                            // px: 10,
                            'display': 'flex',
                            'flexDirection': 'row',
                            'justifyContent': 'space-around',
                            'py': 3,
                            'backgroundColor': brand[300],
                            '&:hover': {
                                backgroundColor: brand[400]
                            },
                            'borderRadius': 100,
                            'width': '100%'
                        }}
                            onClick={routeToSignup}
                        >
                            <Typography fontFamily="'DM Sans', sans-serif" fontSize={20} fontWeight={900} color="white" >
                                GET GONZY
                            </Typography>
                            <NavigateNextRoundedIcon color="inherit" className="bg-white rounded-lg" />
                        </Button>
                    </Box>
                    <Box className="flex flex-col md:flex-row justify-start items-start" columnGap={3} marginTop={5}>
                        <Box>
                            <Box className="flex flex-row gap-x-2">
                                <CheckCircleRoundedIcon className="text-[#fab515] hover-text-5f8cff" />
                                <Typography fontFamily="'DM Sans', sans-serif" fontWeight={600} fontSize={18}>
                                    Close highly-targeted leads
                                </Typography>
                            </Box>
                            <Box className="flex flex-row gap-x-2" marginTop={5}>
                                <CheckCircleRoundedIcon className="text-[#fab515] hover-text-5f8cff" />
                                <Typography fontFamily="'DM Sans', sans-serif" fontWeight={600} fontSize={18}>
                                    10X Your Client Fulfillment
                                </Typography>
                            </Box>
                        </Box>
                        <Box>
                            <Box className="flex flex-row gap-x-2">
                                <CheckCircleRoundedIcon className="text-[#fab515] hover-text-5f8cff" />
                                <Typography fontFamily="'DM Sans', sans-serif" fontWeight={600} fontSize={18}>
                                    Put your client pipeline on autopilot
                                </Typography>
                            </Box>
                            <Box className="flex flex-row gap-x-2" marginTop={5}>
                                <CheckCircleRoundedIcon className="text-[#fab515] text-wrap hover-text-5f8cff" />
                                <Typography fontFamily="'DM Sans', sans-serif" fontWeight={600} fontSize={18}>
                                    Save Hundreds of Hours & Thousands Of Dollars
                                </Typography>
                            </Box>
                        </Box>
                        <Box>
                            <Box className="flex flex-row gap-x-2">
                                <CheckCircleRoundedIcon className="text-[#fab515] hover-text-5f8cff" />
                                <Typography fontFamily="'DM Sans', sans-serif" fontWeight={600} fontSize={18}>
                                    10X Your Sales & Profits
                                </Typography>
                            </Box>
                            <Box className="flex flex-row gap-x-2" marginTop={5}>
                                <CheckCircleRoundedIcon className="text-[#fab515] hover-text-5f8cff" />
                                <Typography fontFamily="'DM Sans', sans-serif" fontWeight={600} fontSize={18}>
                                    And Much More!
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
            {/* Second Block */}
            <Box
                className="bg-[#eff3ff] flex flex-col justify-center items-center"
                sx={{
                    paddingBottom: 4
                }}
            >
                <Box
                    className="text-balance "
                    style={{
                        // overflow: "visible",
                        justifyContent: 'space-between',
                        borderRadius: 0,
                        opacity: 1,
                        alignSelf: 'center',
                        minWidth: '0px',
                        maxWidth: '900px',
                        // order: 1,
                        minHeight: '200px',
                        height: 'max-content',
                        flexGrow: 0,
                        flexShrink: 0,
                        width: 'auto',
                        margin: 0,
                        zIndex: 56,
                        padding: '0px 24px'
                    }}
                >
                    <Typography fontFamily="'DM Sans', sans-serif" fontWeight={700} variant="h3" textAlign="center" marginTop={2} >
                        Clients Are The Bloodline Of Every Business -- Including YOUR Agency.
                    </Typography>
                    <Typography fontSize={18} marginTop={2} marginLeft={4}>
                        But with poor client acquisition, you’ll lose more time and money than you can afford.
                    </Typography>
                    <Typography fontSize={18} marginTop={2} marginLeft={4}>
                        Plus, it’s super difficult to do things like:
                    </Typography>
                </Box>
                {/* The first images div */}
                <Box
                    className="flex flex-wrap items-center justify-center w-full shadow-md py-8 px-4"
                    maxWidth={900}
                    borderRadius={6}
                    bgcolor="white"
                    margin={5}
                >
                    {[
                        { src: '/assets/icon1.png', text: 'Close More Targeted Leads For Your Business' },
                        { src: '/assets/icon2.png', text: 'Instantly Automate Your Prospecting Pipeline.' },
                        { src: '/assets/icon3.png', text: '5X, 10X Or 20X Your Profits In A Fraction Of The Time.' },
                        { src: '/assets/icon4.png', text: 'Engage with customers' }
                    ].map((item, index) => (
                        <Box
                            key={index}
                            className="flex flex-col items-center justify-center w-full sm:w-1/2 lg:w-1/4 p-4 h-full"
                        >
                            <img src={item.src} alt="" width={100} height={100} className="w-24 h-24" />
                            <Typography
                                fontFamily="'DM Sans', sans-serif"
                                fontWeight={700}
                                textAlign="center"
                                marginTop={2}
                                className="px-2"
                            >
                                {item.text}
                            </Typography>
                        </Box>
                    ))}
                </Box>
                <Box
                    className="text-wrap"
                    style={{
                        // overflow: "visible",
                        justifyContent: 'space-between',
                        borderRadius: 0,
                        opacity: 1,
                        alignSelf: 'center',
                        minWidth: '0px',
                        maxWidth: '900px',
                        // order: 1,
                        minHeight: '200px',
                        height: 'max-content',
                        flexGrow: 0,
                        flexShrink: 0,
                        width: 'auto',
                        // marginBottom: 25,
                        zIndex: 56,
                        padding: '0px 44px'
                    }}
                >
                    <Typography fontFamily="'DM Sans', sans-serif" fontSize={18} marginBottom={2}>
                        …among many other things.
                    </Typography>
                    <Typography fontFamily="'DM Sans', sans-serif" fontSize={18} marginBottom={2}>
                        And all at the same time, and on a daily basis!
                    </Typography>
                    <Typography fontFamily="'DM Sans', sans-serif" fontSize={18} marginBottom={2}>
                        Not to mention using multitude of different client-getting platforms that cost you THOUSANDS of dollars every month.<br />
                    </Typography>
                    <Typography fontFamily="'DM Sans', sans-serif" fontSize={18} marginBottom={2}>
                        It’s no wonder agency owners struggle with client acquisition!
                    </Typography>
                    <Typography fontFamily="'DM Sans', sans-serif" fontSize={18} fontWeight={700} marginBottom={2}>
                        What you need is a completely automated client and acquisition platform.
                    </Typography>
                    <Typography fontFamily="'DM Sans', sans-serif" fontSize={18} marginBottom={2}>
                        So you can streamline your entire client-getting process…
                    </Typography>
                    <Typography fontFamily="'DM Sans', sans-serif" fontSize={18} marginBottom={2}>
                        …and close leads and increase profits -- WHILE YOU SLEEP.
                    </Typography>
                    <Typography fontFamily="'DM Sans', sans-serif" fontSize={18} fontWeight={700} marginBottom={2}>
                        And that’s where Gonzy comes in!
                    </Typography>
                    <Typography fontFamily="'DM Sans', sans-serif" fontSize={18} marginBottom={2}>
                        Gonzy’s all-in-one platform let’s you put your entire client and lead gen pipelines -- and client fulfillment --  on autopilot.<br />
                    </Typography>

                    <Typography fontFamily="'DM Sans', sans-serif" fontSize={18} marginBottom={2}>
                        So you can:
                    </Typography>
                </Box>
                <Box
                    className="flex flex-wrap items-center justify-center w-full shadow-md py-8 px-4"
                    maxWidth={750}
                    borderRadius={6}
                    bgcolor="white"
                    margin={5}
                >
                    {[
                        {
                            src: '/assets/icon1-2.jpg',
                            text: 'Close More Targeted Leads For Your Business'
                        },
                        {
                            src: '/assets/icon2-2.jpg',
                            text: 'Instantly Automate Your Prospecting Pipeline.'
                        },
                        {
                            src: '/assets/icon3-2.jpg',
                            text: '5X, 10X Or 20X Your Profits In A Fraction Of The Time.'
                        }
                    ].map((item, index) => (
                        <Box
                            key={index}
                            className="flex flex-col items-center justify-center w-full sm:w-1/2 lg:w-1/3 p-4 h-full"
                        >
                            <img src={item.src} alt="" width={100} height={100} className="w-24 h-24" />
                            <Typography
                                fontFamily="'DM Sans', sans-serif"
                                fontWeight={700}
                                textAlign="center"
                                marginTop={2}
                                className="px-2"
                            >
                                {item.text}
                            </Typography>
                        </Box>
                    ))}
                </Box>
                <Box
                    className="text-balance "
                    style={{
                        // overflow: "visible",
                        justifyContent: 'space-between',
                        borderRadius: 0,
                        opacity: 1,
                        alignSelf: 'center',
                        alignItems: 'center',
                        minWidth: '0px',
                        maxWidth: '1000px',
                        // order: 1,
                        minHeight: '200px',
                        height: 'max-content',
                        flexGrow: 0,
                        flexShrink: 0,
                        width: 'auto',
                        margin: 0,
                        zIndex: 56,
                        padding: '0px 24px'
                    }}>
                    <Box marginBottom={4} className="w-full">
                        <Typography variant="h3" fontFamily="'DM Sans', sans-serif" fontWeight={700} className="text-wrap text-center">
                            Imagine How Much Money & Time You’d Save On A Daily Basis With Automated Client Acquisition!
                        </Typography>
                        <Typography fontFamily="'DM Sans', sans-serif" fontWeight={700} className="text-wrap text-center">
                            Think about how STRESS-FREE you’d be knowing that in minutes You could:
                        </Typography>
                    </Box>
                    <Box className="flex flex-row items-center justify-center">
                        <Box className="flex flex-col items-start justify-start gap-y-4" marginTop={2}>
                            <Box className="flex flex-row">
                                <CheckCircleRoundedIcon className="text-[#fab515] hover-text-5f8cff mr-2" />
                                <Typography fontFamily="'DM Sans', sans-serif" fontWeight={300} fontSize={18}>
                                    Get hot lists of highly qualified leads…
                                </Typography>
                            </Box>
                            <Box className="flex flex-row">
                                <CheckCircleRoundedIcon className="text-[#fab515] hover-text-5f8cff" />
                                <Typography fontFamily="'DM Sans', sans-serif" fontWeight={300} fontSize={18}>
                                    Place them in your automated pipeline
                                </Typography>
                            </Box>
                            <Box className="flex flex-row">
                                <CheckCircleRoundedIcon className="text-[#fab515] mr-2 hover-text-5f8cff text-wrap" />
                                <Typography fontFamily="'DM Sans', sans-serif" fontWeight={300} fontSize={18}>
                                    Close more deals and land more clients
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                    <Box className="flex flex-col items-center justify-center" marginTop={3}>
                        <Typography fontFamily="'DM Sans', sans-serif" fontWeight={200} fontSize={18}>
                            …all in just a few clicks of a button!
                        </Typography>
                        <Typography fontFamily="'DM Sans', sans-serif" fontWeight={200} fontSize={18}>
                            No matter your niche, industry, or business model…
                        </Typography>
                        <Typography fontFamily="'DM Sans', sans-serif" fontWeight={200} fontSize={18}>
                            Making you more money in less time, with little to no effort!
                        </Typography>
                    </Box>
                </Box>
            </Box>
            {/* Third Block */}
            <Box className="flex flex-col justify-center items-center" bgcolor={brand[300]} paddingBottom={7}>
                <Box className="flex flex-row text-balance text-center items-center justify-center" maxWidth={1000} marginTop={3}>
                    <Typography fontFamily="'DM Sans', sans-serif" color="white" fontWeight={700} fontSize={40}>
                        MAKE MORE $MONEY WHILE WORKING LESS… NO MATTER WHAT KIND OF AGENCY BUSINESS YOU HAVE:
                    </Typography>
                </Box>
                <Box className="grid grid-cols-3" columnGap={15} rowGap={5} marginTop={4}>
                    {[
                        { src: '/assets/thirdblock-1.png', description: 'Website Development' },
                        { src: '/assets/thirdblock-2.png', description: 'Digital Marketing' },
                        { src: '/assets/thirdblock-3.png', description: 'Search Engine Optimization' },
                        { src: '/assets/thirdblock-4.png', description: 'App Development' },
                        { src: '/assets/thirdblock-5.png', description: 'Funnel Building' },
                        { src: '/assets/thirdblock-6.png', description: 'Lead Generation' },
                        { src: '/assets/thirdblock-7.png', description: 'Copy Writing' },
                        { src: '/assets/thirdblock-8.png', description: 'E-commerce Building' },
                        { src: '/assets/thirdblock-9.png', description: 'Graphic Design' },
                        { src: '/assets/thirdblock-10.png', description: 'Google Maps' },
                        { src: '/assets/thirdblock-11.png', description: 'Facebook Ads' },
                        { src: '/assets/thirdblock-12.png', description: 'Google Ads' },
                        { src: '/assets/thirdblock-13.png', description: 'Media Buying' },
                        { src: '/assets/thirdblock-14.png', description: 'Youtube Ads' },
                        { src: '/assets/thirdblock-15.png', description: 'Video' }
                    ].map((res, index) => (
                        <Box key={index} className="flex flex-col items-center justify-center gap-y-2">
                            <img src={res.src} alt="l" width={100} height={100} style={{ width: 100, height: 100 }} />
                            <Typography fontFamily="'DM Sans', sans-serif" fontWeight={900} fontSize={18} color="white">
                                {res.description}
                            </Typography>
                        </Box>
                    ))
                    }
                </Box>
            </Box>
            {/* Fourth Block */}
            <Box className="flex flex-col justify-center items-center bg-[#eff3ff] w-full" padding={7}>
                <Box maxWidth={1100} marginTop={7}
                    style={{
                        justifyContent: 'space-between',
                        borderRadius: 0,
                        opacity: 1,
                        alignSelf: 'center',
                        minWidth: '0px',
                        // maxWidth: '1100px',
                        // order: 1,
                        minHeight: '200px',
                        height: 'max-content',
                        flexGrow: 0,
                        flexShrink: 0,
                        width: 'auto',
                        margin: 0,
                        zIndex: 56,
                        padding: '0px 24px'
                    }}
                >
                    <Box className="text-center">
                        <Typography fontFamily="'Caveat', cursive" fontWeight={800} fontSize={30}>
                            No matter your niche...
                        </Typography>
                        <Typography fontFamily="'DM Sans', sans-serif" fontWeight={900} fontSize={50}>
                            Gonzy Is Perfect For Finding Clients In Industries Like…
                        </Typography>
                    </Box>
                    <Box className="grid grid-cols-4" columnGap={10} rowGap={5} marginTop={4}>
                        {[
                            { src: '/assets/4-1.jpg', description: 'Brick & Mortar Businesses' },
                            { src: '/assets/4-2.jpg', description: 'HVAC Providers & Contractors' },
                            { src: '/assets/4-3.jpg', description: 'Medical Practices & Clinics' },
                            { src: '/assets/4-4.jpg', description: 'Roofing & Construction' },
                            { src: '/assets/4-5.jpg', description: 'Dental Practices' },
                            { src: '/assets/4-6.jpg', description: 'Chiropractors' },
                            { src: '/assets/4-7.jpg', description: 'Coaching & Consulting Firms' },
                            { src: '/assets/4-8.jpg', description: 'Massage & Physical Therapists' }
                        ].map((res, index) => (
                            <Box key={index} className="flex flex-col items-center justify-center text-center gap-y-2">
                                <img src={res.src} alt="l" width={100} height={100} style={{ width: 100, height: 100 }} />
                                <Typography fontFamily="'DM Sans', sans-serif" fontWeight={900} fontSize={16} color="black" maxWidth={300}>
                                    {res.description}
                                </Typography>
                            </Box>
                        ))
                        }
                    </Box>
                </Box>
                <Box className="flex flex-row items-start justify-start bg-white p-8 rounded-xl" marginTop={5} maxWidth={1100}>
                    <Box className="flex flex-col justify-start items-start gap-y-6 w-1/2">
                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={30} fontWeight={900} className="text-balance">
                            All The Tools You Need To Close And Fullfill Every Lead
                        </Typography>
                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={18} fontWeight={500} className="text-balance">
                            Using the GONZY system, you will replace thousands of dollars in sales and arm tools,
                            You’ll also save hundreds of hours by having everything in ONE place!
                        </Typography>
                    </Box>
                    <Box className="flex flex-row items-center justify-center">
                        <img src="/assets/table1.png" alt="" width={800} height={400} style={{ width: 700, height: 400 }} className="w-1/2" />
                    </Box>
                </Box>
                <Box className="flex flex-row items-start justify-start bg-white p-2 rounded-xl" marginTop={5} maxWidth={1100}>
                    <Box className="flex flex-row items-center justify-center"
                        minWidth={500}
                        minHeight={500}
                        sx={{
                            borderRadius: '0px',
                            opacity: '1',
                            alignSelf: 'center',
                            flexGrow: 1,
                            height: 'max-content',
                            zIndex: 10,
                            backgroundColor: 'rgba(255, 255, 255, 0)',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                            backgroundImage: 'url(/assets/table2.svg)'
                        }}
                    >

                    </Box>
                    <Box className="flex flex-col justify-start items-start gap-y-6 w-1/2" marginTop={5} marginLeft={3}>
                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={30} fontWeight={900} className="text-balance" width={700}>
                            Get Lists Of Hot-And-Ready Leads In Your Area Within Seconds
                        </Typography>
                        <Box className="flex flex-wrap gap-x-2">
                            <Typography fontFamily="'DM Sans', sans-serif" fontSize={16} fontWeight={500} className="text-balance">
                                Find doctors, chiropractors, plumbers and more in your area.
                            </Typography>
                            <Typography fontFamily="'DM Sans', sans-serif" fontSize={16} fontWeight={800} className="text-balance">
                                Get their contact info, and social links immediately!
                            </Typography>
                        </Box>
                    </Box>
                </Box>
                <Box className="flex flex-row items-start justify-start bg-white p-3 rounded-xl" marginTop={5} maxWidth={1100}>
                    <Box className="flex flex-col justify-start items-start gap-y-6" maxWidth={350} margin={2}>
                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={30} fontWeight={900} className="text-balance" width={700}>
                            Track And Automate Your Client Acquisition Easily
                        </Typography>
                        <Box className="flex flex-wrap gap-x-2">
                            <Typography fontFamily="'DM Sans', sans-serif" fontSize={18} fontWeight={300} className="text-balance">
                                Keep track of
                            </Typography>
                            <Typography fontWeight={800} fontFamily="'DM Sans', sans-serif">seamless, automated client pipelines...</Typography>
                            <Typography fontFamily="'DM Sans', sans-serif" fontSize={18} fontWeight={300} className="text-balance">
                                to close more deals and increase sales in minutes.
                            </Typography>
                        </Box>
                    </Box>
                    <Box className="flex flex-row items-center justify-center">
                        <img src="/assets/table3.svg" alt="" width={800} height={400} style={{ width: 800, height: 400 }} />
                    </Box>
                </Box>
                <Box className="flex flex-row items-start justify-start bg-white p-3 rounded-xl" marginTop={5} maxWidth={1100}>
                    <Box className="flex flex-row items-center justify-center">
                        <img src="/assets/table4.svg" alt="" width={800} height={400} style={{ width: 700, height: 400 }} />
                    </Box>
                    <Box className="flex flex-col justify-start items-start gap-y-6">
                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={30} fontWeight={900} className="text-balance">
                            Automate Customer Relationship Management
                        </Typography>
                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={18} fontWeight={300} className="text-balance" maxWidth={700}>
                            Using the GONZY system, you will replace thousands of dollars in sales and arm tools, You’ll also
                            save hundreds of hours by having everything in ONE place!
                        </Typography>
                    </Box>
                </Box>
            </Box>
            {/* Fifth Block */}
            <Box
                className="flex flex-col items-center justify-center"
                sx={{
                    backgroundImage: 'url(/assets/GOBackground2.jpg)',
                    minHeight: '75vh',
                    width: '100%',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover'
                }}
            >
                <Box className="text-center" marginTop={4}>
                    <Typography fontFamily="'DM Sans', sans-serif" fontSize={40} fontWeight={900} className="text-balance font-extrabold">
                        Join The 23,000+ Other Agency Owners Who Use Gonzy To Make More Money While Saving Even More Time:
                    </Typography>
                </Box>
                <Box maxWidth={1034} minHeight="unset" maxHeight="unset" className="w-full">
                    <img src="/assets/5-1.png" alt="" width={1034} height={600} style={{ width: 1034, height: 600 }} />
                </Box>
                <Box maxWidth={1034} marginBottom={5} width="17%">
                    <Button sx={{
                        'px': 3,
                        'display': 'flex',
                        'flexDirection': 'row',
                        'justifyContent': 'space-around',
                        'py': 3,
                        'backgroundColor': brand[300],
                        '&:hover': {
                            backgroundColor: brand[400]
                        },
                        'borderRadius': 100,
                        'width': '100%'
                    }}
                        onClick={routeToSignup}
                    >
                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={20} fontWeight={900} color="white" >
                            GET GONZY
                        </Typography>
                        <NavigateNextRoundedIcon color="inherit" className="bg-white rounded-lg" />
                    </Button>
                </Box>
                <Box className="flex flex-col items-center justify-center" marginBottom={5}>
                    <Box className="flex flex-col items-center justify-center">
                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={40} fontWeight={900} className="text-balance font-extrabold">
                            A Deep Dive Inside Gonzy
                        </Typography>
                        <Typography fontFamily="'Caveat', cursive" fontSize={40} fontWeight={900} className="text-center font-extrabold">
                            Take A Deeper Look Inside The Holy Grail  Of Customer Acquisition & <br /> Management!
                        </Typography>
                    </Box>
                    <Box className="flex flex-row items-center justify-center">
                        <img src="/assets/5-2.jpg" alt="" width={700} height={600} style={{ width: 600, height: 600 }} />
                    </Box>
                </Box>
            </Box>
            {/* Sixth Block */}
            <Box className="flex flex-col items-center justify-center bg-[#eff3ff]">
                <Box className="flex flex-col items-center justify-center" marginTop={5}>
                    <Typography fontFamily="'DM Sans', sans-serif" fontSize={40} fontWeight={900} className="text-balance font-extrabold">
                        How Gonzy Works
                    </Typography>
                    <Typography fontFamily="'Caveat', cursive" fontSize={40} fontWeight={900} className="text-center font-extrabold">
                        Here&apos;s What Happens When You Merge Prospecting And Pipelines Into <br /> One Tool…
                    </Typography>
                    <Typography fontFamily="'DM Sans', sans-serif" fontSize={30} fontWeight={900} marginTop={2} fontStyle="italic" className="text-balance font-extrabold">
                        Optimize Your Business With Gonzy In 4 Simple Steps:
                    </Typography>
                    {/* Down Arrow Icons */}
                    <DownArrowIcons />
                </Box>
                <Box className="relative">
                    {/* 6-Table-1 */}
                    <Box className="flex flex-row items-start justify-start bg-white p-4 rounded-xl" marginTop={5} maxWidth={1100}>
                        <Box className="flex flex-col justify-start items-start gap-y-2 w-1/2" paddingTop={5} paddingLeft={2}>
                            <Typography fontFamily="'DM Sans', sans-serif" fontSize={40} fontWeight={900} color={brand[300]} className="text-balance">
                                Step 1:
                            </Typography>
                            <div className="min-w-[120px] max-w-[320px] min-h-1 max-h-1 bg-[#fab515]" />
                            <Typography fontFamily="'DM Sans', sans-serif" fontSize={40} fontWeight={900} className="text-wrap font-extrabold">
                                List Your Niche
                            </Typography>
                            <Typography fontFamily="'DM Sans', sans-serif" fontSize={20} fontWeight={300} className="text-wrap">
                                Pick your target audience and location.
                            </Typography>
                            <Typography fontFamily="'DM Sans', sans-serif" fontSize={20} fontWeight={300} marginTop={2} className="text-wrap">
                                Click “search” and get a list of high-quality leads in your area with their contact info and social links in seconds!
                            </Typography>
                        </Box>
                        <Box className="flex flex-row items-center justify-center">
                            <img src="/assets/6-table-1.svg" alt="" width={800} height={400} style={{ width: 700, height: 400 }} />
                        </Box>
                    </Box>
                    {/* Yellow Arrow */}
                    <Box className="absolute top-[19%] flex flex-row items-end justify-end" minWidth={1400} >
                        <img src="/assets/yellowArrow.png" alt="" width={400} height={300} style={{ width: 400, height: 300 }} />
                    </Box>
                    {/* 6-Table-2 */}
                    <Box className="flex flex-row items-start justify-start bg-white p-4 rounded-xl" marginTop={5} maxWidth={1100}>

                        <Box className="flex flex-row items-center justify-center">
                            <img src="/assets/6-table-2.svg" alt="" width={800} height={400} style={{ width: 700, height: 400 }} />
                        </Box>
                        <Box className="flex flex-col justify-start items-start gap-y-2 w-1/2" paddingTop={5} paddingLeft={2}>
                            <Typography fontFamily="'DM Sans', sans-serif" fontSize={40} fontWeight={900} color={brand[300]} className="text-balance">
                                Step 2:
                            </Typography>
                            <div className="min-w-[320px] max-w-[320px] min-h-1 max-h-1 bg-[#fab515]" />
                            <Typography fontFamily="'DM Sans', sans-serif" fontSize={40} fontWeight={900} className="text-wrap font-extrabold">
                                Place Prospects In Your Pipeline
                            </Typography>
                            <Box flexWrap="wrap">
                                <Typography fontFamily="'DM Sans', sans-serif" fontSize={20} fontWeight={300} className="text-wrap">
                                    Place your leads in our proven,
                                </Typography>
                                <Typography fontFamily="'DM Sans', sans-serif" fontSize={20} fontWeight={300} className="text-wrap">
                                    6-stage pipeline process.
                                </Typography>
                            </Box>
                            <Typography fontFamily="'DM Sans', sans-serif" fontSize={20} fontWeight={300} marginTop={2} className="text-wrap">
                                Keep track of each prospects by dragging and dropping them through your pipeline.
                            </Typography>
                        </Box>
                    </Box>
                    {/* Yellow Arrow Left */}
                    <Box className="absolute top-[43%] right-1/4 flex flex-row items-start justify-start w-full">
                        <img src="/assets/yellowArrowLeft.png" alt="" width={400} height={300} style={{ width: 400, height: 300 }} />
                    </Box>
                    {/* 6-Table-3 */}
                    <Box className="flex flex-row items-start justify-start bg-white p-4 rounded-xl" marginTop={5} maxWidth={1100}>
                        <Box className="flex flex-col justify-start items-start gap-y-2 w-1/2" paddingTop={5} paddingLeft={2}>
                            <Typography fontFamily="'DM Sans', sans-serif" fontSize={40} fontWeight={900} color={brand[300]} className="text-balance">
                                Step 3:
                            </Typography>
                            <div className="min-w-[320px] max-w-[320px] min-h-1 max-h-1 bg-[#fab515]" />
                            <Typography fontFamily="'DM Sans', sans-serif" fontSize={40} fontWeight={900} lineHeight={0.9} className="text-wrap font-extrabold">
                                Send Proven Proposal & Invoice Templates
                            </Typography>
                            <Typography fontFamily="'DM Sans', sans-serif" fontSize={20} fontWeight={300} className="text-wrap" marginTop={2}>
                                Once your prospects make it through the end of the pipeline, send them a proposal and invoice.
                            </Typography>
                        </Box>
                        <Box className="flex flex-row items-center justify-center">
                            <img src="/assets/6-table-3.svg" alt="" width={800} height={400} style={{ width: 700, height: 400 }} />
                        </Box>
                    </Box>
                    {/* Yellow Arrow */}
                    <Box className="absolute top-[68%] left-1/4 flex flex-row items-end justify-end w-full">
                        <img src="/assets/yellowArrow.png" alt="" width={400} height={300} style={{ width: 400, height: 300 }} />
                    </Box>
                    {/* 6-Table-4 */}
                    <Box className="flex flex-row items-start justify-start bg-white p-4 rounded-xl" marginTop={5} maxWidth={1100}>
                        <Box className="flex flex-row items-center justify-center">
                            <img src="/assets/6-table-4.svg" alt="" width={800} height={400} style={{ width: 700, height: 400 }} />
                        </Box>
                        <Box className="flex flex-col justify-start items-start gap-y-2 w-1/2" paddingTop={5}>
                            <Typography fontFamily="'DM Sans', sans-serif" fontSize={40} fontWeight={900} color={brand[300]} className="text-balance">
                                Step 4:
                            </Typography>
                            <div className="min-w-[320px] max-w-[320px] min-h-1 max-h-1 bg-[#fab515]" />
                            <Typography fontFamily="'DM Sans', sans-serif" fontSize={30} fontWeight={900} className="text-wrap font-extrabold">
                                Close Prospects & Increase Profits!
                            </Typography>
                            <Typography fontFamily="'DM Sans', sans-serif" fontSize={20} fontWeight={300} className="text-wrap">
                                Close deals and turn prospects into high-paying clients!
                                Then wash, rinse, and repeat!
                            </Typography>
                        </Box>
                    </Box>
                </Box>
                <Box marginY={5}>
                    <Typography fontFamily="'Caveat', cursive" fontSize={40} fontWeight={900} className="text-balance">
                        ... and you&apos;re done!
                    </Typography>
                </Box>
            </Box>
            {/* Seventh Block */}
            <Box className="flex flex-col items-center justify-center bg-white">
                <Box className="flex flex-col items-center justify-center" marginTop={5}>
                    <Typography fontFamily="'DM Sans', sans-serif" fontSize={50} fontWeight={900} lineHeight={0.9} className="text-balance">
                        “But Wait… What Happens AFTER
                    </Typography>
                    <Typography fontFamily="'DM Sans', sans-serif" fontSize={50} fontWeight={900} className="text-balance">
                        I Close A Client? What&apos;s Next?”
                    </Typography>

                    <Box className="flex flex-col justify-start items-start w-full self-center gap-y-3" marginTop={3} maxWidth={1100}>
                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={18} fontWeight={300} className="text-balance">
                            Thought you&apos;d never ask!
                        </Typography>
                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={18} fontWeight={300} className="text-balance">
                            Gonzy doesn&apos;t just automate your client acquisition…
                        </Typography>
                    </Box>
                    <Typography fontFamily="'DM Sans', sans-serif" fontSize={30} fontWeight={900} className="text-balance" marginTop={3}>
                        Gonzy helps you MANAGE your
                    </Typography>
                    <Typography fontFamily="'DM Sans', sans-serif" fontSize={30} fontWeight={900} className="text-balance">
                        newly-acquired clients, too!
                    </Typography>
                    <Box className="flex flex-col justify-start items-start w-full self-center gap-y-3" marginTop={3} maxWidth={1100}>
                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={18} fontWeight={300} className="text-balance">
                            Imagine taking ONLY the BEST features of  the most efficient marketing tools on the internet…
                        </Typography>
                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={18} fontWeight={300} className="text-balance">
                            …and putting them on ONE platform?
                        </Typography>
                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={18} fontWeight={900} className="text-balance">
                            That&apos;s exactly what you get with Gonzy!
                        </Typography>
                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={18} fontWeight={300} className="text-balance">
                            Not only did we combine the internet&apos;s GREATEST marketing tools into one easy platform…
                        </Typography>
                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={18} fontWeight={300} className="text-balance">
                            We also stripped all the non-important things (you have to pay extra for)...
                        </Typography>
                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={18} fontWeight={300} className="text-balance">
                            Which ALSO means…
                        </Typography>
                        <Box>
                            <img src="/assets/7-2.jpg" alt="" width={1000} height={600} style={{ width: 1000, height: 600 }} />
                        </Box>

                    </Box>
                    <Typography fontFamily="'DM Sans', sans-serif" fontSize={40} fontWeight={900} className="text-center">
                        WE&apos;VE INTEGRATED ALL THESE THINGS INTO GONZY!
                    </Typography>
                    <Box className="flex flex-col justify-start items-start w-full self-center gap-y-3" marginTop={3} maxWidth={1100}>
                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={18} fontWeight={700} className="text-balance">
                            That&apos;s right… Gonzy is when client acquisition meets client management & fulfillment!
                        </Typography>
                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={18} fontWeight={300} className="text-balance">
                            So you NEVER have to worry about getting lost with the “operational” side of your business.
                        </Typography>
                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={18} fontWeight={300} className="text-balance">
                            Or get distracted with a ton of different tools!
                        </Typography>
                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={18} fontWeight={300} className="text-balance">
                            Instead, you can spend your time on what really matters:
                        </Typography>
                        <Box className="flex flex-col justify-start items-start" rowGap={2} marginTop={5}>
                            <Box className="flex flex-row gap-x-2">
                                <CheckCircleRoundedIcon className="text-[#fab515] hover-text-5f8cff" />
                                <Typography fontFamily="'DM Sans', sans-serif" fontWeight={600} fontSize={18}>
                                    Improving Your Client-Getting Strategies
                                </Typography>
                            </Box>
                            <Box className="flex flex-row gap-x-2">
                                <CheckCircleRoundedIcon className="text-[#fab515] hover-text-5f8cff" />
                                <Typography fontFamily="'DM Sans', sans-serif" fontWeight={600} fontSize={18}>
                                    Closing MORE Clients FASTER
                                </Typography>
                            </Box>

                            <Box className="flex flex-row gap-x-2">
                                <CheckCircleRoundedIcon className="text-[#fab515] hover-text-5f8cff" />
                                <Typography fontFamily="'DM Sans', sans-serif" fontWeight={600} fontSize={18}>
                                    Producing HIGHER-QUALITY work for your clients
                                </Typography>
                            </Box>
                            <Box className="flex flex-row gap-x-2">
                                <CheckCircleRoundedIcon className="text-[#fab515] text-wrap hover-text-5f8cff" />
                                <Typography fontFamily="'DM Sans', sans-serif" fontWeight={600} fontSize={18}>
                                    Charging HIGHER FEES for projects and retainers
                                </Typography>
                            </Box>
                            <Box className="flex flex-row gap-x-2" marginBottom={5}>
                                <CheckCircleRoundedIcon className="text-[#fab515] hover-text-5f8cff" />
                                <Typography fontFamily="'DM Sans', sans-serif" fontWeight={600} fontSize={18}>
                                    And so much more!
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
            {/* Eigth Block */}
            <Box className="flex flex-col items-center justify-center bg-[#eff3ff]">
                <Box marginTop={5}>
                    <Typography fontFamily="'DM Sans', sans-serif" fontSize={40} fontWeight={900} className="text-center">
                        Manage & Close Deals Straight From The<br />Gonzy Platform -- And So Much More!
                    </Typography>
                    <Typography color="#2F2F2F" marginY={3} fontFamily="'DM Sans', sans-serif" fontSize={25} fontWeight={300} className="text-center">
                        Other Gonzy features include:
                    </Typography>
                </Box>
                {/* Down Arrow Icons */}
                <DownArrowIcons />
                {/* 8-Table-1 */}
                <Box className="flex flex-row items-start justify-start bg-white p-4 rounded-xl" marginTop={5} maxWidth={1100}>
                    <Box className="flex flex-col justify-start items-start gap-y-2 w-1/2" paddingTop={5} paddingLeft={2}>
                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={40} fontWeight={900} className=" text-balance">
                            All-Seeing Dashboard
                        </Typography>
                        <Typography fontFamily="'Caveat', cursive" fontSize={27} fontWeight={600} className="text-wrap">
                            Get a high-level snapshot of what&apos;s going on in your business.
                        </Typography>
                    </Box>
                    <Box className="flex flex-row items-center justify-center"
                        sx={{
                            backgroundImage: 'url(/assets/8-table-1.svg)',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                            minHeight: 400,
                            minWidth: 600
                        }}
                    >
                    </Box>
                </Box>
                {/* 8-Table-2 */}
                <Box className="flex flex-row items-start justify-start bg-white p-4 rounded-xl" marginTop={5} maxWidth={1100}>
                    <Box
                        className="flex flex-row items-center justify-center"
                        sx={{
                            backgroundImage: 'url(/assets/8-table-2.svg)',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: '100% auto',
                            backgroundPosition: 'center 80%',
                            minHeight: 400,
                            minWidth: 570,
                            maxWidth: 600
                        }}
                    >
                    </Box>
                    <Box className="flex flex-col justify-start items-start gap-y-2 w-1/2" paddingTop={5} paddingLeft={2}>
                        <Typography lineHeight={1} fontFamily="'DM Sans', sans-serif" fontSize={40} fontWeight={900} className=" text-balance">
                            Autopilot Client Acquisition
                        </Typography>
                        <Typography fontFamily="'Caveat', cursive" lineHeight={1} marginTop={2} fontSize={27} fontWeight={600} className="text-wrap">
                            Automate tasks and workflows, and create sequences with triggers, pipelines, and more.
                        </Typography>
                    </Box>
                </Box>
                {/* 8-Table-3 */}
                <Box className="flex flex-row items-start justify-start bg-white p-4 rounded-xl" marginTop={5} maxWidth={1100}>
                    <Box className="flex flex-col justify-start items-start gap-y-2 w-1/2" paddingTop={5} paddingLeft={2}>
                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={40} lineHeight={1} fontWeight={900} className=" text-wrap">
                            Automated Seamless Billing
                        </Typography>
                        <Typography fontFamily="'Caveat', cursive" fontSize={27} lineHeight={1} fontWeight={700} marginTop={2} className="text-wrap">
                            Gonzy integrates with Stripe so you can directly collect invoices through recurring billing, one-time payments, or other options.
                        </Typography>
                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={18} fontWeight={400} lineHeight={1} marginTop={2} className="text-wrap">
                            No more sketchy, complicated processes to receive payments from your customers.
                        </Typography>
                    </Box>
                    <Box
                        className="flex flex-row items-center justify-center"
                        sx={{
                            backgroundImage: 'url(/assets/8-table-3.svg)',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: '100% auto',
                            backgroundPosition: 'center 700%',
                            minHeight: 400,
                            minWidth: 570,
                            maxWidth: 600
                        }}
                    >
                    </Box>
                </Box>
                {/* 8-Table-4 */}
                <Box className="flex flex-row items-start justify-start bg-white p-4 rounded-xl" marginTop={5} maxWidth={1100}>
                    <Box
                        className="flex flex-row items-center justify-center"
                        sx={{
                            backgroundImage: 'url(/assets/8-table-4.svg)',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: '100% auto',
                            backgroundPosition: 'center 80%',
                            minHeight: 400,
                            minWidth: 570,
                            maxWidth: 600
                        }}
                    >
                    </Box>
                    <Box className="flex flex-col justify-start items-start gap-y-2 w-1/2" paddingTop={5} paddingLeft={2}>
                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={40} lineHeight={1} fontWeight={900} className=" text-wrap">
                            Upload & Export Your Own Lists Of Leads
                        </Typography>
                        <Typography fontFamily="'Caveat', cursive" fontSize={33} lineHeight={1} fontWeight={700} marginTop={2} className="text-wrap">
                            Upload and export your own lead lists. You can even review previous searches.
                        </Typography>
                    </Box>
                </Box>
                {/* 8-Table-5 */}
                <Box className="flex flex-row items-start justify-start bg-white p-4 rounded-xl" marginTop={5} maxWidth={1100}>
                    <Box className="flex flex-col justify-start items-start gap-y-2 w-1/2" paddingTop={5} paddingLeft={2}>
                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={40} lineHeight={1} fontWeight={900} className=" text-balance">
                            Create Multiple Pipelines At Once
                        </Typography>
                        <Typography fontFamily="'Caveat', cursive" fontSize={27} lineHeight={1} fontWeight={700} marginTop={2} className="text-pretty">
                            Create any number of pipelines for leads in any niche or industry.
                        </Typography>
                    </Box>
                    <Box
                        className="flex flex-row items-center justify-center"
                        sx={{
                            backgroundImage: 'url(/assets/8-table-5.svg)',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: '100% auto',
                            backgroundPosition: ' center',
                            minHeight: 400,
                            minWidth: 570,
                            maxWidth: 600
                        }}
                    >
                    </Box>
                </Box>
                {/* 8-Table-6 */}
                <Box className="flex flex-row items-start justify-start bg-white p-4 rounded-xl" marginTop={5} maxWidth={1100}>
                    <Box
                        className="flex flex-row items-center justify-center"
                        sx={{
                            backgroundImage: 'url(/assets/8-table-6.svg)',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                            minHeight: 350,
                            minWidth: 500,
                            maxWidth: 600
                        }}
                    >
                    </Box>
                    <Box className="flex flex-col justify-start items-start gap-y-2 w-1/2" paddingTop={5} paddingLeft={2}>
                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={40} lineHeight={1} fontWeight={900} className="text-balance">
                            10X Your Profits With “Hot Deals” Feature
                        </Typography>
                        <Typography fontFamily="'Caveat', cursive" fontSize={27} lineHeight={1} fontWeight={700} marginTop={2} className="text-wrap">
                            Our “Hot Deals” feature lets you know when leads respond to your automation sequences, so you can engage them instantly and close more sales.
                        </Typography>
                    </Box>
                </Box>
                {/* 8-Table-7 */}
                <Box className="flex flex-row items-start justify-start bg-white p-4 rounded-xl" marginTop={5} maxWidth={1100}>
                    <Box className="flex flex-col justify-start items-start gap-y-2 w-1/2" paddingTop={5} paddingLeft={2}>
                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={40} lineHeight={1} fontWeight={900} className=" text-wrap">
                            Prospect Rolodex
                        </Typography>
                        <Typography fontFamily="'Caveat', cursive" fontSize={27} lineHeight={1} fontWeight={700} marginTop={2} className="text-wrap">
                            Let&apos;s you keep a neat list of all your prospects from each of your pipelines. Include notes about prospects, too!
                        </Typography>
                    </Box>
                    <Box
                        className="flex flex-row items-center justify-center"
                        sx={{
                            backgroundImage: 'url(/assets/8-table-7.svg)',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: '100% auto',
                            backgroundPosition: 'center 80%',
                            minHeight: 400,
                            minWidth: 570,
                            maxWidth: 600
                        }}
                    >
                    </Box>
                </Box>
                {/* 8-Table-8 */}
                <Box className="flex flex-row items-start justify-start bg-white p-4 rounded-xl" marginTop={5} maxWidth={1100}>
                    <Box
                        className="flex flex-row items-center justify-center"
                        sx={{
                            backgroundImage: 'url(/assets/8-table-8.svg)',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                            minHeight: 450,
                            minWidth: 570,
                            maxWidth: 600
                        }}
                    >
                    </Box>
                    <Box className="flex flex-col justify-start items-start gap-y-2 w-1/2" paddingTop={5} paddingLeft={2}>
                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={40} lineHeight={1} fontWeight={900} className=" text-wrap">
                            Task Management<br /> Lists
                        </Typography>
                        <Typography fontFamily="'Caveat', cursive" fontSize={27} lineHeight={1} fontWeight={700} marginTop={2} className="text-wrap">
                            Create To-Do lists for your pipelines, prospects, team members, and more to keep your business organized, client fulfillment, and productivity flowing.
                        </Typography>
                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={21} lineHeight={1} fontWeight={400} marginTop={2} className="text-wrap">
                            Keeps day-to-day client retention tasks organized and easy to execute.
                        </Typography>
                    </Box>
                </Box>
                {/* 8-Table-9 */}
                <Box className="flex flex-row items-start justify-start bg-white p-4 rounded-xl" marginTop={5} maxWidth={1100}>
                    <Box className="flex flex-col justify-start items-start gap-y-2 w-1/2" paddingTop={5} paddingLeft={2}>
                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={40} lineHeight={1} fontWeight={900} className=" text-balance">
                            Communicate With Your Team With “Watercooler” Feature
                        </Typography>
                        <Typography fontFamily="'Caveat', cursive" fontSize={27} lineHeight={1} fontWeight={700} marginTop={2} className="text-wrap">
                            Message people on the internal client fulfillment team about a specific client to keep up with your clients customer journey.
                        </Typography>
                    </Box>
                    <Box
                        className="flex flex-row items-center justify-center"
                        sx={{
                            backgroundImage: 'url(/assets/8-table-9.svg)',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: '100% auto',
                            // backgroundPosition: 'center 80%',
                            minHeight: 380,
                            minWidth: 470,
                            maxWidth: 600
                        }}
                    >
                    </Box>
                </Box>
                {/* 8-Table-10 */}
                <Box className="flex flex-row items-start justify-start bg-white p-4 rounded-xl shadow-md" marginTop={5} maxWidth={1100}>
                    <Box
                        className="flex flex-row items-center justify-center"
                    >
                        <img src="/assets/8-table-10.svg" alt="logo" width={600} height={400} style={{
                            objectFit: 'contain'
                        }} />
                    </Box>
                    <Box className="flex flex-col justify-start items-start gap-y-2 w-1/2" paddingTop={13} paddingLeft={2}>
                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={40} lineHeight={1} fontWeight={900} className=" text-wrap">
                            Keep track with the Gonzy Calendar
                        </Typography>
                        <Typography fontFamily="'Caveat', cursive" fontSize={27} lineHeight={1} fontWeight={700} marginTop={2} className="text-wrap">
                            See everything that you have assigned, due dates, across all pipelines, etc.
                        </Typography>
                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={20} lineHeight={1} fontWeight={400} marginTop={2} className="text-wrap">
                            Gonzy can also sync to your external calendar apps.
                        </Typography>
                    </Box>
                </Box>
                <Box className="flex flex-row items-center justify-center w-full" marginTop={5}
                    sx={{
                        backgroundImage: 'url(/assets/GOBackground3.jpg)',
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover'
                    }}
                >
                    <Box className="flex flex-col items-center justify-center p-4" marginTop={10}>
                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={40} lineHeight={1} color="white" fontWeight={900} className=" text-wrap">
                            Integratable with:
                        </Typography>
                        <Box>
                            <img src="/assets/9-1.jpg" alt="logo" width={600} height={400} style={{
                                objectFit: 'contain'
                            }} />
                        </Box>
                    </Box>
                </Box>
            </Box>
            {/* Ninth Block */}
            <Box className="flex flex-col items-center justify-center">
                <Box className="flex flex-col items-center justify-center p-4 w-full">
                    <Typography fontFamily="'DM Sans', sans-serif" fontSize={55} lineHeight={1} letterSpacing={3} marginTop={5} fontWeight={900} className=" text-wrap text-center text-[#2f2f2f]">
                        Automate Your Client <br /> Acquisition & Lead <br />Generation With Gonzy <br /> Today!
                    </Typography>
                    <Typography fontFamily="'Caveat', cursive" fontSize={35} lineHeight={1} letterSpacing={0.5} marginTop={5} fontWeight={900} className=" text-wrap text-center text-[#2f2f2f]">
                        All those other inferior CRM and client-getting platforms can finally be <br />GON-ZY!
                    </Typography>
                </Box>
                <Box className="grid grid-cols-2 items-center justify-center bg-white" marginBottom={5}>
                    <Box className="flex flex-col items-center justify-center md:pl-[10%]">
                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={18} lineHeight={1} marginTop={5} fontWeight={300} className=" text-wrap text-start text-[#2f2f2f]">
                            Because now you can generate leads and <br />acquire clients on autopilot…
                            <br /><br />
                            …and increase sales and profits with little to  <br />no effort!
                            <br /><br />
                            All from using ONE single platform that cuts  <br />HOURS off your workload and saves you  <br />thousands of dollars every month.
                            <br /><br />
                            Talk about an unfair advantage!
                            <br /><br />
                            Gonzy has everything you need to get more <br /> clients and take your business to the next <br /> level.
                            <br /><br />
                            So what are you waiting for?
                            <br /><br />
                            Get Gonzy today!
                        </Typography>
                        <Box marginTop={5} width="50%">
                            <Button sx={{
                                'display': 'flex',
                                'flexDirection': 'row',
                                'justifyContent': 'space-around',
                                'py': 3,
                                'backgroundColor': brand[300],
                                '&:hover': {
                                    backgroundColor: brand[400]
                                },
                                'borderRadius': 100,
                                'width': '100%'
                            }}
                                onClick={routeToSignup}
                            >
                                <Typography fontFamily="'DM Sans', sans-serif" fontSize={20} fontWeight={900} color="white" >
                                    GET GONZY
                                </Typography>
                                <NavigateNextRoundedIcon color="inherit" className="bg-white rounded-full" />
                            </Button>
                        </Box>
                    </Box>
                    <Box className="bg-white">
                        <img
                            src={'/assets/last-1.jpg'}
                            alt=""
                            width={600}
                            height={480}
                            style={{ width: 600, height: 480 }} />
                    </Box>
                </Box>
            </Box>
            <Box
                className="text-center p-28"
                sx={{
                    backgroundImage: 'url(\'/assets/GOBackgrounds1.png\')',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat'
                }}
            >
                <Typography fontFamily="'DM Sans', sans-serif" fontSize={55} lineHeight={1} letterSpacing={3} marginTop={5} fontWeight={900} className=" text-wrap text-center text-[#2f2f2f]">
                    FAQs
                </Typography>
            </Box>

            {/* Footer */}
            <Box
                className="bg-[#232323] flex flex-col items-center justify-center p-12"
                sx={{
                }}
            >
                <Box className="flex flex-row items-center justify-between w-full" maxWidth={1100}>
                    <img
                        src="/assets/logo-dark.png"
                        alt=""
                        width={300}
                        height={80}
                        style={{ width: 300, height: 80 }} />
                    <Box>
                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={12} lineHeight={1} letterSpacing={0.8} marginTop={5} fontWeight={900} className=" text-wrap text-center text-white">
                            © 2021-2025 Gonzy, LLC. | All Rights Reserved
                        </Typography>
                        <Box className="flex flex-row items-center justify-around">
                            <button className=" text-wrap text-center text-white" onClick={() => navigate('/privacy')}>
                                <Typography fontFamily="'DM Sans', sans-serif" color="#fab515" fontSize={13} lineHeight={1} letterSpacing={0.8} marginTop={1} fontWeight={900} className="hover-text-3a4d8f">
                                    Privacy Policy
                                </Typography>
                            </button>
                            <button className=" text-wrap text-center text-white" onClick={() => navigate('/term')}>
                                <Typography fontFamily="'DM Sans', sans-serif" color="#fab515" fontSize={13} lineHeight={1} letterSpacing={0.8} marginTop={1} fontWeight={900} className="hover-text-3a4d8f">
                                    Terms of Use
                                </Typography>
                            </button>
                        </Box>
                    </Box>
                </Box>
                <div className="max-w-[1100px] min-w-[1100px] mt-8 min-h-[1.5px] mb-44 max-h-1 bg-white" />
            </Box>
        </div>
    );
};

export default LandingPage;

// <Box
//                className="flex flex-col items-center justify-center"
//                sx={{
//                    backgroundImage: 'url(/assets/GOBackground4.jpg)',
//                    backgroundRepeat: 'no-repeat',
//                    backgroundSize: 'cover'
//                }}
//            >
//                <Box className="flex flex-col items-center justify-center gap-y-3" marginTop={5}>
//                    <Typography fontFamily="'Caveat', cursive" fontSize={45} lineHeight={1} fontWeight={900} className=" text-center text-[#2F2F2F]">
//                        But Just When You Thought Gonzy Couldn&apos;t Get Any <br />Better…
//                    </Typography>
//                    <Typography fontFamily="'DM Sans', sans-serif" fontSize={45} lineHeight={1} fontWeight={900} marginTop={2} className="text-center text-[#1D2E3B]">
//                        You&apos;ll Even Get With 1-On-1 AND <br />Group Coaching!
//                    </Typography>
//                    <Typography fontFamily="'DM Sans', sans-serif" fontSize={40} lineHeight={1} fontWeight={900} marginTop={2} className="text-center italic" color={brand[300]}>
//                        ($5,000 VALUE)
//                    </Typography>
//                    <Box marginTop={5}>
//                        <img src="/assets/9-2.jpg" alt="logo" width={500} height={500} style={{
//                            width: 500,
//                            height: 500
//                        }} />
//                    </Box>
//                    {/* Content Under Image */}
//                    <Box className="flex flex-col items-start justify-start md:pl-[10%]">
//                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={18} lineHeight={1} fontWeight={300}
// marginTop={2} className="text-center text-wrap text-[#2F2F2F]">
//                            As if closing clients on autopilot wasn&apos;t cool enough…
//                        </Typography>
//                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={18} lineHeight={1} fontWeight={300}
// marginTop={2} className="text-center text-wrap text-[#2F2F2F]">
//                            And as if combining the best client-management tools into one platform wasn&apos;t enough…
//                        </Typography>
//                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={18} lineHeight={1} fontWeight={300}
// marginTop={2} className="text-center text-wrap text-[#2F2F2F]">
//                            We decided to pretty much guarantee your success with 1-On-1 and group coaching!
//                        </Typography>
//                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={18} lineHeight={1} fontWeight={300}
// marginTop={2} className="text-center text-wrap text-[#2F2F2F]">
//                            That&apos;s right… When you get Gonzy today, you&apos;ll get access to:
//                        </Typography>
//                        <Box className="flex flex-col justify-start items-start" rowGap={2} marginTop={5}>
//                            <Box className="flex flex-row gap-x-2">
//                                <CheckCircleRoundedIcon className="text-[#fab515] hover-text-5f8cff" />
//                                <Typography fontFamily="'DM Sans', sans-serif" fontWeight={400} fontSize={18}>
//                                    <strong>1-On-1 Coaching with one of our incredible coaches</strong> (who&apos;ve, by the way,
//                                    have already built 6 and 7 figure businesses using Gonzy!).
//                                </Typography>
//                            </Box>
//                            <Box className="flex flex-row gap-x-2">
//                                <CheckCircleRoundedIcon className="text-[#fab515] hover-text-5f8cff" />
//                                <Typography fontFamily="'DM Sans', sans-serif" fontWeight={400} fontSize={18}>
//                                    <strong>Q & A Lives 3 Times A Week </strong>- with other Gonzy users who&apos;ve ALSO built 6 and 7 figure businesses.
//                                </Typography>
//                            </Box>
//
//                            <Box className="flex flex-row gap-x-2">
//                                <CheckCircleRoundedIcon className="text-[#fab515] hover-text-5f8cff" />
//                                <Typography fontFamily="'DM Sans', sans-serif" fontWeight={400} fontSize={18}>
//                                    <strong>Group Coaching</strong> with other Gonzy users and get coaching for ANY problem you&apos;re having on your journey to success.
//                                </Typography>
//                            </Box>
//                            <Box className="flex flex-row gap-x-2">
//                                <CheckCircleRoundedIcon className="text-[#fab515] text-wrap hover-text-5f8cff" />
//                                <Typography fontFamily="'DM Sans', sans-serif" fontWeight={600} fontSize={18}>
//                                    And so much more!
//                                </Typography>
//                            </Box>
//                        </Box>
//                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={18} lineHeight={1} fontWeight={300}
// marginTop={2} className="text-center text-wrap text-[#2F2F2F]">
//                            The amount of value you&apos;ll get from this bonus alone is PRICELESS.
//                        </Typography>
//                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={18} lineHeight={1} fontWeight={300}
// marginTop={2} className="text-center text-wrap text-[#2F2F2F]">
//                            In the past, clients paid upwards of $5,000 for coaching -- while using a LITE version of Gonzy!
//                        </Typography>
//                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={18} lineHeight={1} fontWeight={300}
// marginTop={2} className="text-center text-wrap text-[#2F2F2F]">
//                            But today, not only will you get the BEST and EASIEST version of Gonzy ever made…
//                        </Typography>
//                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={18} lineHeight={1} fontWeight={300}
// marginTop={2} className="text-center text-wrap text-[#2F2F2F]">
//                            The coaching you&apos;ll get with it will give you a MASSIVE shortcut success in a fraction of the time!
//                        </Typography>
//                    </Box>
//
//                    <Box marginTop={5} marginBottom={3}>
//                        <Typography fontFamily="'Caveat', cursive" fontSize={40} fontWeight={900} color="#2F2F2F" className="text-center">
//                            And that&apos;s not all...
//                        </Typography>
//                    </Box>
//                    <Typography fontFamily="'DM Sans', sans-serif" fontSize={45} lineHeight={1} fontWeight={900} marginTop={2} className="text-center text-[#2F2F2F]">
//                        You&apos;ll Also Get Josh Osborne&apos;s 6 <br /> Steps-To-Close Client Kick Starter <br /> System!
//                    </Typography>
//                    <Typography fontFamily="'DM Sans', sans-serif" fontSize={40} lineHeight={1} fontWeight={900} marginTop={2} className="text-center italic" color={brand[300]}>
//                        ($6,000 VALUE)
//                    </Typography>
//                    <Box marginTop={5}>
//                        <img src="/assets/9-3.jpg" alt="logo" width={500} height={400} style={{
//                            width: 500,
//                            height: 333.33
//                        }} />
//                    </Box>
//                    <Box className="flex flex-col items-start justify-start md:pl-[5%]">
//                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={20} lineHeight={1} fontWeight={300} marginTop={2} className=" text-wrap text-[#2F2F2F]">
//                            There are 6 proven steps in Gonzy&apos;s client pipeline…
//                            <br /><br />
//                            In this special program, Josh Osborne breaks down these 6-steps to ensure you FLOOD your pipelines<br /> with hungry leads and high-paying clients!
//                            <br /><br />
//                            By the time you&apos;re done with this program, you&apos;ll know exactly how and where to put your <br />
//                            prospects in the pipeline to nearly confirm your success.
//                            <br /><br />
//                            You&apos;re likely to have more clients and projects in your pipeline than you could handle.
//                            <br /><br />
//                            Before you know it, you&apos;ll be joining the rest of our 6 and 7 figure earners helping other Gonzy <br /> members succeed.
//                            <br /><br />
//                            (Don&apos;t say we didn&apos;t warn you!)
//                            <br /><br />
//                            Oh, and did we mention this program comes with its own list of special bonuses?
//                            <br /><br />
//                            You&apos;ll get instant access to these bonuses too, as soon as you get Gonzy today!
//                        </Typography>
//                    </Box>
//                    <Typography fontFamily="'Caveat', cursive" fontSize={40} lineHeight={1} fontWeight={900} marginTop={10} className="text-center text-[#2F2F2F]">
//                        We&apos;ve ALSO Thrown In:
//                    </Typography>
//                    <Typography fontFamily="'DM Sans', sans-serif" fontSize={45} lineHeight={1} fontWeight={900} marginTop={2} className="text-center text-[#2F2F2F]">
//                        Proven, Ready-To Go Client <br /> Acquisition Templates!
//                    </Typography>
//                    <Typography fontFamily="'DM Sans', sans-serif" fontSize={40} lineHeight={1} fontWeight={900} marginTop={2} className="text-center italic" color={brand[300]}>
//                        ($1000 VALUE)
//                    </Typography>
//                    <Box marginTop={5}>
//                        <img src="/assets/9-4.jpg" alt="logo" width={500} height={400} style={{
//                            width: 500,
//                            height: 400
//                        }} />
//                    </Box>
//                    <Box className="flex flex-col items-start justify-start md:pl-[5%]">
//                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={20} lineHeight={1} fontWeight={300} marginTop={2} className=" text-wrap text-[#2F2F2F]">
//                            On top of the 1-on-1 and group coaching…
//                            <br /><br />
//                            AND Josh&apos;s 6-Steps-To-Close Client Kickstarter System…
//                            <br /><br />
//                            We wanted to FURTHER ensure your success by providing you with proven, ready-to-go<br /> client acquisitions!
//                            <br /><br />
//                            So now, you don&apos;t even have to start from scratch!
//                            <br /><br />
//                            We took proven strategies of our most successful students AND coaches… and turned them<br /> into easily implementable templates!
//                            <br /><br />
//                            Simply plug-and-play ANY of these templates, and you&apos;re on your way to landing and managing<br />
//                            more high-paying clients than you ever thought possible.
//                            <br /><br />
//                            You won&apos;t find a single one of these templates anywhere else online and can only get <br />them when you get Gonzy today.
//                            <br /><br />
//                        </Typography>
//                    </Box>
//                    <Box marginTop={5} width="15%">
//                        <Button sx={{
//                            // px: 10,
//                            'display': 'flex',
//                            'flexDirection': 'row',
//                            'justifyContent': 'space-around',
//                            'py': 3,
//                            'backgroundColor': brand[300],
//                            '&:hover': {
//                                backgroundColor: brand[400]
//                            },
//                            'borderRadius': 100,
//                            'width': '100%'
//                        }}
//                            onClick={routeToSignup}
//                        >
//                            <Typography fontFamily="'DM Sans', sans-serif" fontSize={20} fontWeight={900} color="white" >
//                                GET GONZY
//                            </Typography>
//                            <NavigateNextRoundedIcon color="inherit" className="bg-white rounded-full" />
//                        </Button>
//                    </Box>
//                </Box>
//            </Box>
//            {/* Money Back Guarantee */}
//            <Box className="relative flex flex-col items-center justify-center top-[150px]">
//                <Box className="top-[-120px] left-[50%] translate-x-[-50%] absolute" width={280} height={280}>
//                    <img src="/assets/9-5.jpg" alt="logo" width={280} height={280} style={{
//                        width: 280,
//                        height: 280
//                    }} />
//                </Box>
//                <Box className="flex flex-col items-center justify-center p-4 border-2 pt-[10%] rounded-lg bg-white shadow-md" maxWidth={900}>
//                    <Typography fontFamily="'DM Sans', sans-serif" fontSize={50} lineHeight={1} fontWeight={900} marginTop={2} className="text-center text-wrap text-[#2F2F2F]">
//                        Gonzy Also Comes With A 30-<br />Day Money-Back Guarantee!
//                    </Typography>
//                    <Typography fontFamily="'DM Sans', sans-serif" fontSize={20} lineHeight={1} fontWeight={300} marginTop={3} className="text-center text-wrap text-[#2F2F2F]">
//                        If you are not completely satisfied with Gonzy after 30 days, reach out to our customer service team to request a full refund, no questions asked!
//                    </Typography>
//                </Box>
//            </Box>
//            {/* Last Block */}
//            <Box className="flex flex-col items-center justify-center bg-[#eff3ff]">
//                <Box marginTop={20}>
//                    <Typography fontFamily="'Caveat', cursive" fontSize={45} lineHeight={1} fontWeight={900} marginTop={2} color={brand[300]} className="text-center text-wrap">
//                        So to round things up...
//                    </Typography>
//                    <Typography fontFamily="'DM Sans', sans-serif" fontSize={45} lineHeight={1} fontWeight={900} marginTop={5} className="text-center text-wrap">
//                        Here&apos;s Everything <br />You&apos;re Getting:
//                    </Typography>
//                </Box>
//                <Box className="flex flex-row items-start justify-start bg-white p-4 rounded-xl" marginTop={5} maxWidth={1200}>
//                    <Box className="flex flex-row items-center justify-center"
//                        sx={{
//                            backgroundImage: 'url(/assets/10-1.jpg)',
//                            backgroundRepeat: 'no-repeat',
//                            backgroundSize: 'contain',
//                            backgroundPosition: 'center',
//                            minHeight: 400,
//                            minWidth: 500
//                        }}
//                    >
//                    </Box>
//                    <Box className="flex flex-col justify-start items-start gap-y-2 w-1/2" paddingTop={10} paddingLeft={2}>
//                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={40} lineHeight={1} fontWeight={900} className=" text-[#2f2f2f] text-balance">
//                            Gonzy&apos;s Incredible, ALL-IN-ONE Client Acquisition & Management Platform
//                        </Typography>
//                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={18} marginTop={3} fontWeight={400} className="text-wrap text-[#2f2f2f]">
//                            Get the #1 Client-Getting & Management Platform for Agency Owners.
//                        </Typography>
//                    </Box>
//                </Box>
//                <Box className="flex flex-row items-start justify-start bg-white p-4 rounded-xl" marginTop={5} maxWidth={1200}>
//                    <Box className="flex flex-row items-center justify-center"
//                        sx={{
//                            backgroundImage: 'url(/assets/10-2.jpg)',
//                            backgroundRepeat: 'no-repeat',
//                            backgroundSize: 'contain',
//                            backgroundPosition: 'center',
//                            minHeight: 400,
//                            minWidth: 500
//                        }}
//                    >
//                    </Box>
//                    <Box className="flex flex-col justify-start items-start gap-y-2 w-1/2" paddingTop={5} paddingLeft={2}>
//                        <Typography fontFamily="'Caveat', cursive" fontSize={35} lineHeight={1} fontWeight={900} marginY={3} className="text-[#2f2f2f]">
//                            Bonus 1:
//                        </Typography>
//                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={35} lineHeight={1} fontWeight={900} className=" text-balance text-[#2f2f2f]">
//                            On-1 & Group Coaching
//                        </Typography>
//                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={25} color={brand[300]} marginTop={1} fontWeight={900} className="text-wrap">
//                            ($5,000 Value)
//                        </Typography>
//                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={18} marginTop={1} fontWeight={400} className="text-wrap text-[#2f2f2f]">
//                            Get 1-On-1 Coaching, Group Coaching, and Live Q & A&apos;s 3 times a week, from 6 and 7-figure
//                            business owners who use Gonzy! Get ready to get all your questions answered as you shortcut your way to success!
//                        </Typography>
//                    </Box>
//                </Box>
//                <Box className="flex flex-row items-start justify-start bg-white p-4 rounded-xl" marginTop={5} maxWidth={1200}>
//                    <Box className="flex flex-row items-center justify-center"
//                        sx={{
//                            backgroundImage: 'url(/assets/10-3.jpg)',
//                            backgroundRepeat: 'no-repeat',
//                            backgroundSize: 'contain',
//                            backgroundPosition: 'center',
//                            minHeight: 400,
//                            minWidth: 500
//                        }}
//                    >
//                    </Box>
//                    <Box className="flex flex-col justify-start items-start gap-y-2 w-1/2" paddingTop={5} paddingLeft={2}>
//                        <Typography fontFamily="'Caveat', cursive" fontSize={35} lineHeight={1} fontWeight={900} marginY={3} className="text-[#2f2f2f]">
//                            Bonus 2:
//                        </Typography>
//                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={35} lineHeight={1} fontWeight={900} className=" text-balance text-[#2f2f2f]">
//                            Josh&apos;s 6-Steps-To-Close Client Kickstarter Program
//                        </Typography>
//                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={25} color={brand[300]} marginTop={1} fontWeight={900} className="text-wrap">
//                            ($6,000 Value)
//                        </Typography>
//                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={18} marginTop={1} fontWeight={400} className="text-wrap text-[#2f2f2f]">
//                            Get proven, ready-to-go templates created from the strategies of our 6 and 7 figure students and
//                            coaches so you don&apos;t have to waste time starting from scratch!
//                        </Typography>
//                    </Box>
//                </Box>
//                <Box className="flex flex-row items-start justify-start bg-white p-4 rounded-xl" marginTop={5} maxWidth={1200}>
//                    <Box className="flex flex-row items-center justify-center"
//                        sx={{
//                            backgroundImage: 'url(/assets/10-4.jpg)',
//                            backgroundRepeat: 'no-repeat',
//                            backgroundSize: 'contain',
//                            backgroundPosition: 'center',
//                            minHeight: 400,
//                            minWidth: 500
//                        }}
//                    >
//                    </Box>
//                    <Box className="flex flex-col justify-start items-start gap-y-2 w-1/2" paddingTop={5} paddingLeft={2}>
//                        <Typography fontFamily="'Caveat', cursive" fontSize={35} lineHeight={1} fontWeight={900} marginY={3} className="text-[#2f2f2f]">
//                            Bonus 3:
//                        </Typography>
//                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={35} lineHeight={1} fontWeight={900} className=" text-balance text-[#2f2f2f]">
//                            Proven, Read-To-Go Client-Acquisition Templates
//                        </Typography>
//                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={25} color={brand[300]} marginTop={1} fontWeight={900} className="text-wrap">
//                            ($1,000 Value)
//                        </Typography>
//                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={18} marginTop={1} fontWeight={400} className="text-wrap text-[#2f2f2f]">
//                            Get proven, ready-to-go templates created from the strategies of our 6 and 7 figure students and coaches so
//                            you don&apos;t have to waste time starting from scratch!
//                        </Typography>
//                    </Box>
//                </Box>
//                <Box className="grid grid-cols-[1.2fr_1.5fr] items-start justify-start bg-white p-4 rounded-xl" marginBottom={5} marginTop={5} maxWidth={1200}>
//                    <Box className="flex flex-row items-center justify-center"
//                        sx={{
//                            backgroundImage: 'url(/assets/10-5.jpg)',
//                            backgroundRepeat: 'no-repeat',
//                            backgroundSize: 'contain',
//                            backgroundPosition: 'right 20% center',
//                            minHeight: 300,
//                            minWidth: 300
//                        }}
//                    >
//                    </Box>
//                    <Box className="flex flex-col justify-start items-start gap-y-2 w-full" paddingTop={15}>
//                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={45} lineHeight={1} fontWeight={900} className=" text-wrap text-[#2f2f2f]">
//                            30-Day Money Back Guarantee!
//                        </Typography>
//                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={18} marginTop={1} fontWeight={400} className="text-wrap text-[#2f2f2f]">
//                            If you&apos;re not closing higher-paying clients on autopilot in 30 days or less, we&apos;ll give you every cent back, no questions asked.
//                        </Typography>
//                    </Box>
//                </Box>
//            </Box>
//            <Box
//                className="flex flex-col items-center justify-center p-4"
//                sx={{
//                    backgroundImage: 'url(/assets/GOBackground3.jpg)',
//                    backgroundRepeat: 'no-repeat',
//                    backgroundSize: 'cover'
//                }}>
//                <Typography fontFamily="'DM Sans', sans-serif" fontSize={60} lineHeight={1} marginTop={5} fontWeight={900} className=" text-wrap text-center text-white">
//                    Get Gonzy & Over $12,000<br /> Worth Of Bonuses For $297 <br />A Month!
//                </Typography>
//                <Box marginTop={5} width="15%">
//                    <Button sx={{
//                        'display': 'flex',
//                        'flexDirection': 'row',
//                        'justifyContent': 'space-around',
//                        'py': 3,
//                        'backgroundColor': '#eeb65c',
//                        '&:hover': {
//                            backgroundColor: '#eeb600'
//                        },
//                        'borderRadius': 100,
//                        'width': '100%'
//                    }}
//                        onClick={routeToSignup}
//                    >
//                        <Typography fontFamily="'DM Sans', sans-serif" fontSize={20} fontWeight={900} color="white" >
//                            GET GONZY
//                        </Typography>
//                        <NavigateNextRoundedIcon color="inherit" className="bg-white rounded-full" />
//                    </Button>
//                </Box>
//            </Box>
//            <Box className="flex flex-col items-center justify-center p-4 bg-[#eff3ff]">
//                <Box className="flex flex-col items-center justify-center p-4 w-full">
//                    <Typography fontFamily="'DM Sans', sans-serif" fontSize={45} lineHeight={1} marginTop={5} fontWeight={900} className=" text-wrap text-center text-[#2f2f2f]">
//                        Testimonials
//                    </Typography>
//                    <Box>
//                        <img
//                            src={'/assets/5-1.png'}
//                            alt=""
//                            width={1034}
//                            height={600}
//                            style={{ width: 1034, height: 600 }} />
//                    </Box>
//                    <Box marginTop={5} width="15%">
//                        <Button sx={{
//                            'display': 'flex',
//                            'flexDirection': 'row',
//                            'justifyContent': 'space-around',
//                            'py': 3,
//                            'backgroundColor': brand[300],
//                            '&:hover': {
//                                backgroundColor: brand[400]
//                            },
//                            'borderRadius': 100,
//                            'width': '100%'
//                        }}
//                            onClick={routeToSignup}
//                        >
//                            <Typography fontFamily="'DM Sans', sans-serif" fontSize={20} fontWeight={900} color="white" >
//                                GET GONZY
//                            </Typography>
//                            <NavigateNextRoundedIcon color="inherit" className="bg-white rounded-full" />
//                        </Button>
//                    </Box>
//                </Box>
//            </Box>